import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const ModalInfo = ({
  notification,
  setOpenModal,
  openModal,
  onAccept,
  closeOnPrimaryClick = false,
  children,
  image,
}) => {
  const imageSrc = notification?.image || image || '';
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [imageSrc]);

  const hasImage = Boolean(imageSrc) && !imageFailed;
  const hasButton = Boolean(notification?.button);
  const isImageOnly = hasImage && !notification?.title && !notification?.text && !hasButton && !children;

  const closeModal = () => {
    setOpenModal(false);
  };

  const handleAccept = () => {
    if (onAccept) onAccept();
    if (closeOnPrimaryClick) closeModal();
  };

  return (
    <div className={`modal-info ${openModal ? 'open' : ''}`}>
      <div className="overlay" onClick={closeModal} aria-hidden="true" />

      <div className={`modal-info__container ${hasImage ? 'modal-info__container--media' : ''}`.trim()}>
        <button
          className="modal-info__close"
          onClick={closeModal}
          aria-label="Закрити"
          type="button"
        >
          ✕
        </button>

        <div
          className={[
            'modal-info__content',
            'modal-info__content--gap',
            hasImage ? 'modal-info__content--media' : '',
            isImageOnly ? 'modal-info__content--image-only' : '',
          ].filter(Boolean).join(' ')}
        >
          {hasImage && (
            <img
              className="modal-info__image"
              src={imageSrc}
              alt={notification?.title ? '' : 'Оголошення New Brain'}
              onError={() => setImageFailed(true)}
            />
          )}

          {notification?.title && (
            <div
              className="modal-info__title"
              dangerouslySetInnerHTML={{ __html: notification.title }}
            />
          )}

          {notification?.text && (
            <div
              className="modal-info__text"
              dangerouslySetInnerHTML={{ __html: notification.text }}
            />
          )}

          {children ? (
            children
          ) : hasButton && (
            <div className="modal-info-btns">
              {notification?.button && (
                <div
                  className="modal-info-btns-wrapper"
                  onClick={handleAccept}
                  dangerouslySetInnerHTML={{ __html: notification.button }}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ModalInfo.propTypes = {
  notification: PropTypes.object.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  openModal: PropTypes.bool.isRequired,
  onAccept: PropTypes.func,
  closeOnPrimaryClick: PropTypes.bool,
  children: PropTypes.node,
  image: PropTypes.string,
};

export default ModalInfo;
// import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';

// const ModalInfo = ({
//   notification,
//   setOpenModal,
//   openModal,
//   onAccept,
//   hideNoButton = false,
//   closeOnPrimaryClick = false,
//   enableInteractions = true,
// }) => {
//   const [elTarget, setElTarget] = useState(null);
//   const [clickCount, setClickCount] = useState(0);

//   const getClickData = (target) => {
//     if (!enableInteractions) return;
//     setElTarget(target);
//     setClickCount((prev) => prev + 1);
//   };

//   const closeModal = () => {
//     setOpenModal(false);
//     document.body.classList.remove('open');
//   };

//   const handleAccept = () => {
//     if (onAccept) onAccept();
//     if (closeOnPrimaryClick) closeModal();
//   };

//   useEffect(() => {
//     if (!enableInteractions) return;

//     if (clickCount <= 4 && clickCount > 0) {
//       if (elTarget?.dataset.el === 'btn') {
//         if (clickCount === 4) {
//           closeModal();
//         } else {
//           elTarget.classList.add(clickCount % 2 === 0 ? 'move-right' : 'move-left');
//           elTarget.classList.add('shake');
//           setTimeout(() => elTarget.classList.remove('shake'), 600);
//         }
//       }

//       if (elTarget?.dataset.el === 'overlay') {
//         if (clickCount >= 4) {
//           closeModal();
//         } else {
//           elTarget.classList.add('bg');
//           setTimeout(() => elTarget.classList.remove('bg'), 400);
//         }
//       }
//     }
//   }, [clickCount, elTarget, enableInteractions]);

//   return (
//     <div className={`modal-info ${openModal ? 'open' : ''}`}>
//       <div
//         className="overlay"
//         data-el="overlay"
//         onClick={(e) => getClickData(e.target)}
//       />
//       <div className="modal-info__container">
//         {/* Хрестик тільки якщо немає кнопки «Ні» */}
//         {hideNoButton && (
//           <button
//             className="modal-info__close"
//             onClick={closeModal}
//             aria-label="Закрити"
//           >
//             ✕
//           </button>
//         )}

//         <div className="modal-info__content modal-info__content--gap">
//           {notification?.title && (
//             <div
//               className="modal-info__title"
//               dangerouslySetInnerHTML={{ __html: notification.title }}
//             />
//           )}

//           <div
//             className="modal-info__text"
//             dangerouslySetInnerHTML={{ __html: notification?.text }}
//           />

//           <div className="modal-info-btns">
//             {notification?.button && (
//               <div
//                 className="modal-info-btns-wrapper modal-info-btns-wrapper--move"
//                 onClick={handleAccept}
//                 dangerouslySetInnerHTML={{ __html: notification.button }}
//               />
//             )}

//             {!hideNoButton && (
//               <button
//                 className="modal-info__no link link--tt-sm move"
//                 data-el="btn"
//                 onClick={(e) => getClickData(e.target)}
//               >
//                 Ні
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// ModalInfo.propTypes = {
//   notification: PropTypes.object.isRequired,
//   setOpenModal: PropTypes.func.isRequired,
//   openModal: PropTypes.bool.isRequired,
//   onAccept: PropTypes.func,
//   hideNoButton: PropTypes.bool,
//   closeOnPrimaryClick: PropTypes.bool,
//   enableInteractions: PropTypes.bool,
// };

// export default ModalInfo;